import { EditorObject } from 'utils/responsiveTypes'

const galleryDense: EditorObject = {
  x: 290.00000000000045,
  y: 129,
  id: 'cguu4pi1lf3si6ghq1mixtn0i',
  name: '2 Column Gallery Section',
  type: 'LAYOUT_SECTION',
  width: 1221.9999999999995,
  height: 316,
  hidden: false,
  mobile: {
    x: 0,
    y: 20,
    width: 1512,
    height: 690,
    pushGraph: {
      edges: [],
      nodeIds: ['0nmpr1ov9ufyz7s21idsubd58'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'CENTER',
    },
  },
  shadow: {
    x: 0,
    y: 2,
    size: 4,
    color: 'rgba(0, 0, 0, 0.2)',
    enabled: false,
  },
  shared: {
    mobile: false,
    tablet: false,
    desktop: false,
  },
  tablet: {
    x: 0,
    y: 20,
    width: 1512,
    height: 695,
    pushGraph: {
      edges: [],
      nodeIds: ['0nmpr1ov9ufyz7s21idsubd58'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'CENTER',
    },
  },
  actions: {},
  desktop: {
    x: 0,
    y: 20,
    width: 1512,
    height: 777,
    pushGraph: {
      edges: [],
      nodeIds: ['0nmpr1ov9ufyz7s21idsubd58'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'CENTER',
    },
  },
  opacity: 1,
  children: [
    {
      x: 290.00000000000045,
      y: 179,
      id: '0nmpr1ov9ufyz7s21idsubd58',
      name: 'Layout Helper',
      type: 'section',
      width: 1221.9999999999995,
      height: 216,
      hidden: false,
      mobile: {
        x: 0,
        y: 38,
        width: 1512,
        height: 654,
        pushGraph: {
          edges: [],
          nodeIds: ['9vx3yixj6q9cqti1hvpqvqksz'],
        },
      },
      shadow: {
        x: 0,
        y: 2,
        size: 4,
        color: 'rgba(0, 0, 0, 0.2)',
        enabled: false,
      },
      shared: {
        mobile: true,
        tablet: true,
        desktop: true,
      },
      tablet: {
        x: 0,
        y: 35,
        width: 1512,
        height: 665,
        pushGraph: {
          edges: [],
          nodeIds: ['9vx3yixj6q9cqti1hvpqvqksz'],
        },
      },
      actions: {},
      desktop: {
        x: 0,
        y: 36,
        width: 1512,
        height: 745,
        pushGraph: {
          edges: [],
          nodeIds: ['9vx3yixj6q9cqti1hvpqvqksz'],
        },
      },
      opacity: 1,
      purpose: 'layout_helper',
      children: [
        {
          x: 500.9999999999998,
          y: 179,
          id: '9vx3yixj6q9cqti1hvpqvqksz',
          name: 'Container',
          type: 'section',
          width: 800,
          height: 216,
          hidden: false,
          mobile: {
            x: 62.030769230769344,
            y: 38,
            width: 1387.938461538461,
            height: 654,
            pushGraph: {
              edges: [],
              nodeIds: ['8t1isp6rlixvli2qicxywfuw9'],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          shadow: {
            x: 0,
            y: 2,
            size: 4,
            color: 'rgba(0, 0, 0, 0.2)',
            enabled: false,
          },
          shared: {
            mobile: false,
            tablet: false,
            desktop: false,
          },
          tablet: {
            x: 194.6726618705036,
            y: 35,
            width: 1127.6546762589928,
            height: 665,
            pushGraph: {
              edges: [],
              nodeIds: ['8t1isp6rlixvli2qicxywfuw9'],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          actions: {},
          desktop: {
            x: 260.9999999999999,
            y: 36,
            width: 990.0000000000002,
            height: 745,
            pushGraph: {
              edges: [],
              nodeIds: ['8t1isp6rlixvli2qicxywfuw9'],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          opacity: 1,
          purpose: 'container',
          children: [
            {
              x: 500.9999999999998,
              y: 195,
              id: '8t1isp6rlixvli2qicxywfuw9',
              name: 'List  24',
              type: 'list',
              width: 800.0000000000099,
              height: 623,
              hidden: false,
              mobile: {
                x: 62.030769230769344,
                y: 54,
                width: 1387.938461538461,
                height: 623,
                pushGraph: {
                  edges: [
                    {
                      distance: 11,
                      endNodeId: 'd5a58rhwfl49jqn8ks2xdvvrw',
                      startNodeId: 'avqp000on9tml61dru0lhtgdr',
                    },
                    {
                      distance: 15,
                      endNodeId: 'euo0w3ha0rbnz3p6653yztzsb',
                      startNodeId: 'avqp000on9tml61dru0lhtgdr',
                    },
                    {
                      distance: 6,
                      endNodeId: '4ypv9coc8wg85i2bucztq6wm4',
                      startNodeId: 'd5a58rhwfl49jqn8ks2xdvvrw',
                    },
                    {
                      distance: 6,
                      endNodeId: '4ypv9coc8wg85i2bucztq6wm4',
                      startNodeId: 'euo0w3ha0rbnz3p6653yztzsb',
                    },
                    {
                      distance: 5,
                      endNodeId: '5rl0m67daaffpmi70mqvhu6vx',
                      startNodeId: '4ypv9coc8wg85i2bucztq6wm4',
                    },
                  ],
                  nodeIds: [
                    'avqp000on9tml61dru0lhtgdr',
                    'd5a58rhwfl49jqn8ks2xdvvrw',
                    'euo0w3ha0rbnz3p6653yztzsb',
                    '4ypv9coc8wg85i2bucztq6wm4',
                    '5rl0m67daaffpmi70mqvhu6vx',
                  ],
                },
                positioning: 'fixedTop',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              shared: {
                mobile: false,
                tablet: false,
                desktop: false,
              },
              tablet: {
                x: 199.02990559638837,
                y: 51,
                width: 1118.9401888072232,
                height: 623,
                pushGraph: {
                  edges: [
                    {
                      distance: 11,
                      endNodeId: 'd5a58rhwfl49jqn8ks2xdvvrw',
                      startNodeId: 'avqp000on9tml61dru0lhtgdr',
                    },
                    {
                      distance: 15,
                      endNodeId: 'euo0w3ha0rbnz3p6653yztzsb',
                      startNodeId: 'avqp000on9tml61dru0lhtgdr',
                    },
                    {
                      distance: 6,
                      endNodeId: '4ypv9coc8wg85i2bucztq6wm4',
                      startNodeId: 'd5a58rhwfl49jqn8ks2xdvvrw',
                    },
                    {
                      distance: 6,
                      endNodeId: '4ypv9coc8wg85i2bucztq6wm4',
                      startNodeId: 'euo0w3ha0rbnz3p6653yztzsb',
                    },
                    {
                      distance: 5,
                      endNodeId: '5rl0m67daaffpmi70mqvhu6vx',
                      startNodeId: '4ypv9coc8wg85i2bucztq6wm4',
                    },
                  ],
                  nodeIds: [
                    'avqp000on9tml61dru0lhtgdr',
                    'd5a58rhwfl49jqn8ks2xdvvrw',
                    'euo0w3ha0rbnz3p6653yztzsb',
                    '4ypv9coc8wg85i2bucztq6wm4',
                    '5rl0m67daaffpmi70mqvhu6vx',
                  ],
                },
                positioning: 'fixedTop',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              actions: {
                '4kt7wl0buoc4pyiyuocorbtkh': {
                  type: 'action',
                  actions: [
                    {
                      id: 'e3mepgm0y2hzy1nszuzj68dc6',
                      options: {
                        target: '6nh16krc7oy5tgwduxfvu4l3q',
                        transition: 'TRANSITION_NONE',
                      },
                      actionType: 'navigate',
                    },
                  ],
                  eventType: 'tap',
                },
              },
              desktop: {
                x: 260.9999999999999,
                y: 52,
                width: 990.0000000000002,
                height: 720,
                pushGraph: {
                  edges: [
                    {
                      distance: 13,
                      endNodeId: 'd5a58rhwfl49jqn8ks2xdvvrw',
                      startNodeId: 'avqp000on9tml61dru0lhtgdr',
                    },
                    {
                      distance: 16,
                      endNodeId: 'euo0w3ha0rbnz3p6653yztzsb',
                      startNodeId: 'avqp000on9tml61dru0lhtgdr',
                    },
                    {
                      distance: 5,
                      endNodeId: '4ypv9coc8wg85i2bucztq6wm4',
                      startNodeId: 'd5a58rhwfl49jqn8ks2xdvvrw',
                    },
                    {
                      distance: 5,
                      endNodeId: '4ypv9coc8wg85i2bucztq6wm4',
                      startNodeId: 'euo0w3ha0rbnz3p6653yztzsb',
                    },
                    {
                      distance: 5,
                      endNodeId: '5rl0m67daaffpmi70mqvhu6vx',
                      startNodeId: '4ypv9coc8wg85i2bucztq6wm4',
                    },
                  ],
                  nodeIds: [
                    'avqp000on9tml61dru0lhtgdr',
                    'd5a58rhwfl49jqn8ks2xdvvrw',
                    'euo0w3ha0rbnz3p6653yztzsb',
                    '4ypv9coc8wg85i2bucztq6wm4',
                    '5rl0m67daaffpmi70mqvhu6vx',
                  ],
                },
                positioning: 'fixedTop',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              masonry: true,
              opacity: 1,
              children: [
                {
                  x: 500.9999999999998,
                  y: 427,
                  id: '4ypv9coc8wg85i2bucztq6wm4',
                  name: null,
                  text: 'The No-Code App Builder',
                  type: 'label',
                  color: 'rgba(0, 0, 0, 1)',
                  width: 800.0000000000099,
                  height: 23,
                  hidden: false,
                  mobile: {
                    x: 62.030769230769344,
                    y: 286,
                    width: 1387.938461538461,
                    height: 23,
                  },
                  shared: {
                    mobile: true,
                    tablet: true,
                    desktop: false,
                  },
                  tablet: {
                    x: 199.02990559638837,
                    y: 283,
                    width: 529.4700944036116,
                    height: 23,
                  },
                  actions: {},
                  desktop: {
                    x: 260.9999999999999,
                    y: 324,
                    width: 465.0000000000001,
                    height: 23,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'LEFT_AND_RIGHT',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 20,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: true,
                  fontFamily: '@heading',
                  fontWeight: '700',
                  layoutText: ['Name'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'LEFT_AND_RIGHT',
                  },
                  initialDevice: 'mobile',
                  textAlignment: 'left',
                  inResponsiveApp: true,
                  calculatedFontFamily:
                    'Libre Baskerville, -apple-system, "SF Pro Text", sans-serif',
                },
                {
                  x: 500.9999999999998,
                  y: 401,
                  id: 'euo0w3ha0rbnz3p6653yztzsb',
                  name: null,
                  text: 'Adalo',
                  type: 'label',
                  color: 'rgba(158, 158, 158, 1)',
                  width: 744.0000000000099,
                  height: 17,
                  hidden: false,
                  mobile: {
                    x: 62.030769230769344,
                    y: 260,
                    width: 1331.938461538461,
                    height: 17,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'LEFT_AND_RIGHT',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 198.5299055963884,
                    y: 257,
                    width: 491.47009440361126,
                    height: 17,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'LEFT_AND_RIGHT',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 260.9999999999999,
                    y: 298,
                    width: 413.0000000000001,
                    height: 17,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'LEFT_AND_RIGHT',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 14,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: true,
                  fontFamily: '@body',
                  // fontWeight: '600',
                  layoutText: ['Name'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'LEFT_AND_RIGHT',
                  },
                  initialDevice: 'mobile',
                  textAlignment: 'left',
                  inResponsiveApp: true,
                  calculatedFontFamily:
                    'Open Sans, -apple-system, "SF Pro Text", sans-serif',
                },
                {
                  x: 500.9999999999998,
                  y: 455,
                  id: '5rl0m67daaffpmi70mqvhu6vx',
                  name: null,
                  text: 'Our easy-to-use no-code app builder creates apps for mobile devices & the web. The only question is, what will you build?',
                  type: 'label',
                  color: 'rgba(117, 117, 117, 1)',
                  width: 800.0000000000099,
                  height: 17,
                  hidden: false,
                  mobile: {
                    x: 62.030769230769344,
                    y: 314,
                    width: 1387.938461538461,
                    height: 17,
                  },
                  shared: {
                    mobile: true,
                    tablet: true,
                    desktop: false,
                  },
                  tablet: {
                    x: 199.02990559638837,
                    y: 311,
                    width: 529.4700944036116,
                    height: 17,
                  },
                  actions: {},
                  desktop: {
                    x: 260.9999999999999,
                    y: 352,
                    width: 465.0000000000001,
                    height: 17,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'LEFT_AND_RIGHT',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 14,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  // fontWeight: 'normal',
                  layoutText: [
                    'High-energy moves meet fun in a calorie blast!',
                  ],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'LEFT_AND_RIGHT',
                  },
                  initialDevice: 'mobile',
                  textAlignment: 'left',
                  inResponsiveApp: true,
                  calculatedFontFamily:
                    'Open Sans, -apple-system, "SF Pro Text", sans-serif',
                },
                {
                  x: 500.9999999999998,
                  y: 195,
                  id: 'avqp000on9tml61dru0lhtgdr',
                  name: 'Image  7',
                  type: 'image',
                  width: 800.0000000000099,
                  height: 191,
                  hidden: false,
                  mobile: {
                    x: 62.030769230769344,
                    y: 54,
                    width: 1387.938461538461,
                    height: 191,
                    pushGraph: {
                      edges: [
                        {
                          distance: 89,
                          endNodeId: 'b53se2qfpkuuv7d6pg1nwomlz',
                          startNodeId: '74yajyf47spr08on5foxq2xjt',
                        },
                      ],
                      nodeIds: [
                        '74yajyf47spr08on5foxq2xjt',
                        'b53se2qfpkuuv7d6pg1nwomlz',
                      ],
                    },
                  },
                  shared: {
                    mobile: true,
                    tablet: true,
                    desktop: false,
                  },
                  tablet: {
                    x: 199.02990559638837,
                    y: 51,
                    width: 529.4700944036116,
                    height: 191,
                    pushGraph: {
                      edges: [
                        {
                          distance: 94,
                          endNodeId: 'b53se2qfpkuuv7d6pg1nwomlz',
                          startNodeId: '74yajyf47spr08on5foxq2xjt',
                        },
                      ],
                      nodeIds: [
                        '74yajyf47spr08on5foxq2xjt',
                        'b53se2qfpkuuv7d6pg1nwomlz',
                      ],
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 260.9999999999999,
                    y: 52,
                    width: 465.0000000000001,
                    height: 230,
                    pushGraph: {
                      edges: [
                        {
                          distance: 129,
                          endNodeId: 'b53se2qfpkuuv7d6pg1nwomlz',
                          startNodeId: '74yajyf47spr08on5foxq2xjt',
                        },
                      ],
                      nodeIds: [
                        '74yajyf47spr08on5foxq2xjt',
                        'b53se2qfpkuuv7d6pg1nwomlz',
                      ],
                    },
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [
                    {
                      x: 1140.0000000000095,
                      y: 368,
                      id: 'b53se2qfpkuuv7d6pg1nwomlz',
                      name: 'Button 40',
                      type: 'libraryComponent',
                      width: 132,
                      height: 36,
                      hidden: false,
                      mobile: {
                        x: 1291.9692307692303,
                        y: 187,
                        width: 132,
                        height: 36,
                        positioning: 'fixed',
                        responsivity: {
                          verticalScaling: 'FIXED',
                          horizontalScaling: 'FIXED',
                          verticalPositioning: 'TOP',
                          horizontalPositioning: 'RIGHT',
                        },
                      },
                      shared: {
                        mobile: false,
                        tablet: false,
                        desktop: false,
                      },
                      tablet: {
                        x: 577.5000000000001,
                        y: 189,
                        width: 132,
                        height: 36,
                        positioning: 'fixed',
                        responsivity: {
                          verticalScaling: 'FIXED',
                          horizontalScaling: 'FIXED',
                          verticalPositioning: 'TOP',
                          horizontalPositioning: 'RIGHT',
                        },
                      },
                      actions: {},
                      desktop: {
                        x: 566.9999999999999,
                        y: 225,
                        width: 132,
                        height: 36,
                        positioning: 'fixed',
                        responsivity: {
                          verticalScaling: 'FIXED',
                          horizontalScaling: 'FIXED',
                          verticalPositioning: 'TOP',
                          horizontalPositioning: 'RIGHT',
                        },
                      },
                      opacity: 1,
                      children: [],
                      attributes: {
                        icon: 'star',
                        text: '100%',
                        type: 'contained',
                        shadow: false,
                        upperCase: true,
                        borderRadius: 18,
                        primaryColor: '@background',
                        contrastColor: '@contrast:primaryColor',
                      },
                      libraryName: '@protonapp/material-components',
                      positioning: 'fixed',
                      responsivity: {
                        verticalScaling: 'FIXED',
                        horizontalScaling: 'FIXED',
                        verticalPositioning: 'TOP',
                        horizontalPositioning: 'RIGHT',
                      },
                      componentName: 'Button',
                      initialDevice: 'desktop',
                      libraryVersion: '0.9.49',
                    },
                    {
                      x: 1250.0000000000095,
                      y: 215,
                      id: '74yajyf47spr08on5foxq2xjt',
                      name: 'Toggle 13',
                      type: 'libraryComponent',
                      width: 24,
                      height: 24,
                      hidden: false,
                      mobile: {
                        x: 1398.9692307692303,
                        y: 74,
                      },
                      shared: {
                        mobile: true,
                        tablet: true,
                        desktop: true,
                      },
                      tablet: {
                        x: 677.4999999999999,
                        y: 71,
                      },
                      actions: {},
                      desktop: {
                        x: 674.9999999999999,
                        y: 72,
                      },
                      opacity: 1,
                      children: [],
                      attributes: {
                        activeIcon: 'favorite',
                        toggleSize: 24,
                        activeColor: '@background',
                        inactiveIcon: 'favorite-border',
                        inactiveColor: '@background',
                      },
                      libraryName: '@protonapp/material-components',
                      positioning: 'fixedTop',
                      responsivity: {
                        verticalScaling: 'FIXED',
                        horizontalScaling: 'FIXED',
                        verticalPositioning: 'TOP',
                        horizontalPositioning: 'RIGHT',
                      },
                      componentName: 'IconToggle',
                      initialDevice: 'desktop',
                      libraryVersion: '0.9.49',
                    },
                  ],
                  imageURL: 'https://source.unsplash.com/random/?fitness',
                  imageType: 'uploaded',
                  pushGraph: {
                    edges: [
                      {
                        distance: 129,
                        endNodeId: 'b53se2qfpkuuv7d6pg1nwomlz',
                        startNodeId: '74yajyf47spr08on5foxq2xjt',
                      },
                    ],
                    nodeIds: [
                      '74yajyf47spr08on5foxq2xjt',
                      'b53se2qfpkuuv7d6pg1nwomlz',
                    ],
                  },
                  filename1x: {
                    url: '73d1ddbe9659b3c2038103939f80606ddf04a48c7e77af3f43377a56d7bc0d85.jpg',
                    filename: 'gradient.jpg',
                  },
                  borderColor: '#999',
                  borderStyle: 'none',
                  borderWidth: 1,
                  imageResize: 'cover',
                  positioning: 'fixed',
                  borderRadius: 9,
                  imageBinding: null,
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'mobile',
                  backgroundColor: 'rgba(245, 245, 245, 1)',
                  backgroundStyle: 'color',
                },
                {
                  x: 1273.0000000000098,
                  y: 397,
                  id: 'd5a58rhwfl49jqn8ks2xdvvrw',
                  name: 'Icon 46',
                  type: 'libraryComponent',
                  width: 24,
                  height: 24,
                  hidden: false,
                  mobile: {
                    x: 1421.9692307692305,
                    y: 256,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'FIXED',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'RIGHT',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 700.5,
                    y: 253,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'FIXED',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'RIGHT',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 698,
                    y: 295,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'FIXED',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'RIGHT',
                    },
                  },
                  opacity: 1,
                  children: [],
                  attributes: {
                    iconName: 'more-horiz',
                    iconSize: 24,
                    iconColor: '#9e9e9e',
                  },
                  libraryName: '@protonapp/material-components',
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'FIXED',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'RIGHT',
                  },
                  componentName: 'Icon',
                  initialDevice: 'mobile',
                  libraryVersion: '0.9.49',
                },
              ],
              listType: 'default',
              pushGraph: {
                edges: [
                  {
                    distance: 11,
                    endNodeId: 'd5a58rhwfl49jqn8ks2xdvvrw',
                    startNodeId: 'avqp000on9tml61dru0lhtgdr',
                  },
                  {
                    distance: 15,
                    endNodeId: 'euo0w3ha0rbnz3p6653yztzsb',
                    startNodeId: 'avqp000on9tml61dru0lhtgdr',
                  },
                  {
                    distance: 6,
                    endNodeId: '4ypv9coc8wg85i2bucztq6wm4',
                    startNodeId: 'd5a58rhwfl49jqn8ks2xdvvrw',
                  },
                  {
                    distance: 6,
                    endNodeId: '4ypv9coc8wg85i2bucztq6wm4',
                    startNodeId: 'euo0w3ha0rbnz3p6653yztzsb',
                  },
                  {
                    distance: 5,
                    endNodeId: '5rl0m67daaffpmi70mqvhu6vx',
                    startNodeId: '4ypv9coc8wg85i2bucztq6wm4',
                  },
                ],
                nodeIds: [
                  'avqp000on9tml61dru0lhtgdr',
                  'd5a58rhwfl49jqn8ks2xdvvrw',
                  'euo0w3ha0rbnz3p6653yztzsb',
                  '4ypv9coc8wg85i2bucztq6wm4',
                  '5rl0m67daaffpmi70mqvhu6vx',
                ],
              },
              rowMargin: 60,
              columnCount: 1,
              positioning: 'fixedTop',
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              deviceColumns: {
                mobile: {
                  listType: 'default',
                  rowMargin: 60,
                  columnCount: 1,
                },
                tablet: {
                  listType: 'grid',
                  rowMargin: 60,
                  columnCount: 2,
                },
                desktop: {
                  listType: 'grid',
                  rowMargin: 60,
                  columnCount: 2,
                },
              },
              initialDevice: 'mobile',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              deviceVisibility: {
                mobile: true,
                tablet: true,
                desktop: true,
              },
              columnBreakpoints: 'CUSTOM',
            },
          ],
          pushGraph: {
            edges: [],
            nodeIds: ['8t1isp6rlixvli2qicxywfuw9'],
          },
          borderColor: '#00A996',
          borderStyle: 'none',
          borderWidth: 1,
          positioning: 'fixed',
          borderRadius: 0,
          responsivity: {
            verticalScaling: 'FIXED',
            horizontalScaling: 'SCALES_WITH_PARENT',
            verticalPositioning: 'TOP',
            horizontalPositioning: 'LEFT_AND_RIGHT',
          },
          initialDevice: 'desktop',
          borderPosition: 'center',
          backgroundColor: '@background',
          backgroundStyle: 'none',
        },
      ],
      pushGraph: {
        edges: [],
        nodeIds: ['9vx3yixj6q9cqti1hvpqvqksz'],
      },
      borderColor: '#BDBDBD',
      borderStyle: 'none',
      borderWidth: 1,
      positioning: 'fixed',
      borderRadius: 0,
      responsivity: {
        verticalScaling: 'FIXED',
        horizontalScaling: 'SCALES_WITH_PARENT',
        verticalPositioning: 'TOP',
        horizontalPositioning: 'CENTER',
      },
      initialDevice: 'desktop',
      borderPosition: 'center',
      backgroundColor: '#e0e0e0',
      backgroundStyle: 'none',
    },
  ],
  pushGraph: {
    edges: [],
    nodeIds: ['0nmpr1ov9ufyz7s21idsubd58'],
  },
  borderColor: '#BDBDBD',
  borderStyle: 'none',
  borderWidth: 1,
  imageResize: 'cover',
  positioning: 'fixedTop',
  borderRadius: 0,
  responsivity: {
    verticalScaling: 'FIXED',
    horizontalScaling: 'SCALES_WITH_PARENT',
    verticalPositioning: 'TOP',
    horizontalPositioning: 'CENTER',
  },
  initialDevice: 'desktop',
  borderPosition: 'center',
  backgroundColor: '@background',
  backgroundStyle: 'none',
}

export default galleryDense
